var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceRecognitionOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 14C24 19.5228 19.5228 24 14 24C8.47715 24 4 19.5228 4 14C4 8.47715 8.47715 4 14 4C19.5228 4 24 8.47715 24 14ZM26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14ZM9.5 13C10.3284 13 11 12.3284 11 11.5C11 10.6716 10.3284 10 9.5 10C8.67157 10 8 10.6716 8 11.5C8 12.3284 8.67157 13 9.5 13ZM20 11.5C20 12.3284 19.3284 13 18.5 13C17.6716 13 17 12.3284 17 11.5C17 10.6716 17.6716 10 18.5 10C19.3284 10 20 10.6716 20 11.5ZM14 13.5V15H13V17H16V13.5H14ZM12.3453 19.1217C12.1209 18.7906 12.0009 18.3999 12.0009 18H12H10.0009H10C10 18.7038 10.1857 19.3934 10.5359 20C10.5839 20.0831 10.6349 20.1646 10.689 20.2444C11.138 20.9068 11.7753 21.4192 12.5186 21.7156C13.262 22.0119 14.0771 22.0785 14.8586 21.9068C14.8857 21.9008 14.9127 21.8946 14.9397 21.8881C15.6894 21.7069 16.3713 21.3126 16.9028 20.752L15.128 19.6516L15.1271 19.651C14.917 19.7945 14.6802 19.8973 14.4291 19.9525C14.0385 20.0383 13.6311 20.005 13.2597 19.8569C12.8882 19.7088 12.5697 19.4527 12.3453 19.1217Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceRecognitionOutline);
export default __webpack_public_path__ + "static/media/face_recognition_outline.9ff35a7e17585b5dd28223b894b508e2.svg";
export { ForwardRef as ReactComponent };